import request from '@/utils/request'


export function QueryOrder (data) {
  return request({
    url: '/api/Order/QueryOrder',
    method: 'post',
    data
  })
}

export function QueryAttentionOrder (data) {
  return request({
    url: '/api/Order/QueryAttentionOrder',
    method: 'post',
    data
  })
}


export function GetMemoInfo (params) {
  return request({
    url: '/api/Order/GetMemoInfo',
    method: 'get',
    params
  })
}

export function GetTracking (params) {
  return request({
    url: '/api/Order/GetTracking',
    method: 'get',
    params
  })
}

export function SubmitMemo (data) {
  return request({
    url: '/api/Order/SubmitMemo',
    method: 'post',
    data
  })
}

export function UpdateMemo (data) {
  return request({
    url: '/api/Order/UpdateMemo',
    method: 'post',
    data
  })
}

export function DeleteMemo (id) {
  return request({
    url: '/api/Order/DeleteMemo?id='+id,
    method: 'post'
  })
}

export function SubmitMemoDraftToFormal (data) {
  return request({
    url: '/api/Order/SubmitMemoDraftToFormal',
    method: 'post',
    data
  })
}

export function GetAuthStoreOptions (country) {
  return request({
    url: '/api/Order/GetAuthStoreOptions?country=' + country,
    method: 'get'
  })
}

export function GetProductLabelsAsNid (nid) {
  return request({
    url: '/api/Order/GetProductLabelsAsNid?nid=' + nid,
    method: 'get'
  })
}

export function GetTempChangeOrderAddrInfo (nid) {
  return request({
    url: '/api/Order/GetTempChangeOrderAddrInfo?nid='+nid,
    method: 'get'
  })
}

export function GetChangeAddrLog (orderKey) {
  return request({
    url: '/api/Order/GetChangeAddrLog?orderKey='+orderKey,
    method: 'get'
  })
}

export function SubmitChangeAddr (data) {
  return request({
    url: '/api/Order/SubmitChangeAddr',
    method: 'post',
    data
  })
}

export function GetChangeAddrModifiable (nid) {
  return request({
    url: '/api/Order/GetChangeAddrModifiable?nid='+nid,
    method: 'get'
  })
}

export default { QueryOrder }
